export default __webpack_public_path__ + "bcad9a0e61f5302813a9acffc789c59d.png";